import { api, ApiRequestConfig } from 'api';
import { State, Store } from 'store/types';
import { GlobalEvents } from '../global';
import { FETCH_SHOP_LIST } from './shops-constants';
import { Shop } from './shops-types';

/**
 * Запрос на загрузку списка магазинов
 * @param {string} regionId
 * @param {ApiRequestConfig} config
 * @returns {Promise<Shop>}
 */
export const requestShopList = (
  regionId: string,
  { orchestratorHost, useCredentials, apiKey, requestID }: ApiRequestConfig
): Promise<Shop> => {
  const body = {
    filter: { regionId },
    attributes: ['operationalHours', 'regionIds', 'name'],
    showDescription: false,
  };

  return api.post<Shop>('get-shops', body, { orchestratorHost, useCredentials, apiKey, requestID });
};

/**
 * Экшен загрузки списка магазинов
 * @param {Store} store
 * @returns {Promise<State>}
 */
export const loadShopListAction = (store: Store) =>
  new Promise<State>(resolve => {
    const { modelJson } = store.get();
    if (!modelJson.model) {
      resolve(store.get());
      return;
    }

    store.dispatch(GlobalEvents.setRequestParams, {
      orchestratorHost: process.env.ORCHESTRATOR_HOST,
      apiKey: process.env.API_KEY,
    });

    store.dispatch(FETCH_SHOP_LIST.init);

    const unsub = store.on('@dispatch', state => {
      if (state.shops?.loading) {
        return;
      }

      unsub();
      resolve(store.get());
    });
  });
